import { t } from 'i18next';
import type { ErrorStrategy } from '../types';
import type { I18nKey } from '@/utils/typings';
import { upperFirst } from 'lodash';

export const genericStrategy: ErrorStrategy = ({ instancePath, keyword, params }) => {
  return {
    path: instancePath,
    message: t(`Validation.${upperFirst(keyword)}` as I18nKey, params),
  };
};

/*
  Translation examples from UNIDOS
  "form.validation.enum": "Ungültiger Wert selektiert",
  "form.validation.exclusiveMaximum": "Der Wert muss kleiner als {limit} sein",
  "form.validation.exclusiveMinimum": "Der Wert muss größer als {limit} sein",
  "form.validation.format": "Die Eingabe befindet sich im falschen Format",
  "form.validation.maximum": "Der Wert muss kleiner oder gleich {limit} sein",
  "form.validation.maxLength": "Es sind maximal {limit} Zeichen möglich",
  "form.validation.minimum": "Der Wert muss größer oder gleich {limit} sein",
  "form.validation.minLength": "Der Wert muss aus mindestens {limit} Zeichen bestehen",
  "form.validation.nominalHv": "Der Wert muss im gültigen Nenngebrauchsbereich liegen",
  "form.validation.required": "Eine Eingabe ist erforderlich",
  "form.validation.submit": "Überprüfen Sie Ihre Eingaben",
  "form.validation.type": "Feld muss ein {type} sein",
  */
